import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import YouTube from "react-youtube";
import { UserProfileInline } from "app/components/UserProfileInline";
import { CommentListCollapse } from "../comment/CommentListCollapse";
import { createFetchErrorMessage } from "utils/api/ApiClient";
import Api from "utils/api/Api";
import { toast } from 'react-toastify';
import { VIDEO_STATE } from "lib/const";
import moment from "moment";
import { LikeButton } from "app/components/LikeButton";

export const VideoItem = ({ youtube }) => {
    const { school } = useParams();
    const auth = useSelector((state) => state.auth);

    const isMyItem = useMemo(() => {
        return auth.authenticated && auth.id === youtube.user?.id;
    }, [auth, youtube]);

    // 삭제
    const deleteMutate = useMutation({
        mutationFn: () => Api.get(`/api/youtube/${youtube.id}/delete`),
        onSuccess: (res) => {
            youtube.deleteYn = 'Y';
            youtube.isApple = false;
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err, '삭제요청중 문제가 발생했습니다.');
            toast.error(errorData.message);
        }
    });

    const onClickDelete = () => {
        if (deleteMutate.isPending) return;
        if (!auth.authenticated) return;
        if (youtube.user?.id !== auth.id) {
            alert("삭제 권한이 없습니다.");
            return;
        }

        if (window.confirm("삭제요청 하시겠습니까?")) {
            deleteMutate.mutate();
        }
    }

    const renderVideo = useMemo(() => {
        if (youtube === null) return null;
        if (youtube.state === "reject")
            return <div className="rejectMessage">{youtube.reject_message}</div>;
        if (youtube.state === "delete_request")
            return <div className="rejectMessage">"삭제요청" 중입니다. .</div>;
        if (youtube.state === "delete")
            return <div className="rejectMessage">"삭제" 되었습니다.</div>;

        if ( !youtube.youtubeCode ) return null;
        if (youtube.state !== "active" || youtube.youtubeCode === "") return null;
        const opts = {
            height: "390",
            width: "640",
            playerVars: {
                // https://developers.google.com/youtube/player_parameters
                autoplay: 0,
            },
        };
        console.log(youtube);
        return <YouTube videoId={youtube.youtubeCode} opts={opts} />;
    }, [youtube]);

    if (null === youtube) return null;

    return (
        <div className={`row readingActivityItem ${youtube.state}`}>
            <div className="col3">
                <div className={`book_wrap ${youtube.id} ${youtube.bestYn === "Y" ? "best" : ""}`} >
                    {youtube.bestYn !== "Y" && youtube.goodYn === "Y" && (
                        <div className="stamp good _pc">
                            <img className="good" src={`${process.env.PUBLIC_URL}/images/common/good_stamp.png`} alt="참잘했어요" />
                        </div>
                    )}
                    {youtube.bestYn === "Y" && (
                        <div className="stamp best _pc">
                            <img src={`${process.env.PUBLIC_URL}/images/common/best_stamp.png`} alt="참잘했어요" />
                        </div>
                    )}
                    <Link to={`/${school}/book/${youtube.book.isbn}`}>
                        <div className="book_cover">
                            <div className="book_inner">
                                <img src={youtube.book.image} alt={youtube.book.title} />
                                <div className={`service service_${youtube.book.isService?.toLowerCase()}`}></div>
                            </div>
                        </div>
                    </Link>
                    <div className="book_info">
                        <p className="title">{youtube.book.title}</p>
                        <p className="writer">{youtube.book.author}</p>
                        <p className="pb_company">{youtube.book.publisher}</p>
                        {youtube.bestYn !== "Y" && youtube.goodYn === "Y" && (
                            <div className="stamp good _mobile">
                                <img
                                    className="good"
                                    src={`${process.env.PUBLIC_URL}/images/common/good_stamp.png`}
                                    alt="참잘했어요"
                                />
                            </div>
                        )}
                        {youtube.bestYn === "Y" && (
                            <div className="stamp best _mobile">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/common/best_stamp.png`}
                                    alt="참잘했어요"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="col9">
                <div className="title_area">
                    {isMyItem && <span className={`state ${youtube.state}`}>{VIDEO_STATE[youtube.state]}</span>}
                    <div className="info_wrap">
                        <UserProfileInline
                            id={youtube.user?.id} name={youtube.user?.name || youtube.name}
                            image={youtube.user?.image}
                            type={youtube.user?.type} school={youtube.user?.schoolName}
                            createdAt={moment(youtube.createdAt).format('YYYY.MM.DD')}
                        />
                    </div>
                    <div className="btn_wrap">
                        <LikeButton activity={youtube} type="video" />

                        {youtube.state !== "delete" &&
                            youtube.state !== "delete_request" &&
                            isMyItem && (
                                <button type="button" className="btn _xsm btn_delete" onClick={() => onClickDelete(youtube)}>
                                    삭제요청
                                </button>
                            )}
                    </div>
                </div>

                <div className={`cont_area ${youtube.bestYn === "Y" ? "best" : ""}`}>
                    <div className="cont_wrap">
                        <div className="cont">{renderVideo}</div>
                    </div>
                </div>

                <CommentListCollapse type="VIDEO" root={youtube} />
            </div>
        </div>
    );
};